import React, { useState } from 'react';
import './BecomeCustomer.scss';
import { ServicePlansInfoApi } from '../../api/ServicePlansInfoApi';
import { ServicePlanId } from '../../common';

const BecomeCustomer = () => {
  const api = new ServicePlansInfoApi();

  const [servicePlans, setServicePlans] = useState<any>();
  const [servicePlan, setServicePlan] = useState<any>();
  const [error, setError] = useState<any>();

  const getServicePlans = async () => {
    api
      .getServicePlans()
      .then((plans) => setServicePlans(plans))
      .catch((e) => setError(e.message));
  };

  const getServicePlan = async (servicePlanId: ServicePlanId) => {
    api
      .getServicePlan(servicePlanId)
      .then((plan) => setServicePlan(plan))
      .catch((e) => setError(e.message));
  };

  const prettyPrintJson = (json: any) => {
    return <pre>{JSON.stringify(json, null, 2)}</pre>;
  };

  return (
    <div data-testid="become-customer">
      <h3>Tule asiakkaaksi</h3>
      <button onClick={getServicePlans}>Get service plans</button>
      <br />
      Result:
      <br />
      <div style={{ textAlign: 'left' }}>{prettyPrintJson(servicePlans)}</div>
      <br />
      <br />
      <button onClick={() => getServicePlan(ServicePlanId.OP_CLASSIC)}>Get OP_CLASSIC service plan</button>
      <br />
      Result:
      <br />
      <div style={{ textAlign: 'left' }}>{prettyPrintJson(servicePlan)}</div>
      <br />
      <br />
      {error && (
        <div>
          Error:
          <div>{error}</div>
        </div>
      )}
    </div>
  );
};

export default BecomeCustomer;
